import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassRound: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase
      {...props}
      ariaLabel="compass-round, browser, safari, web, internet, navigation"
    >
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02946 21 3.00002 16.9706 3.00002 12C3.00002 7.02944 7.02946 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M14.8284 9.17156L10 9.99999L9.17158 14.8284L14 14L14.8284 9.17156Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </CentralIconBase>
  );
};

export default IconCompassRound;
